class WalletService {
  constructor(apiClient) {
    this.client = apiClient;
  }

  async createAppleWalletPass(ticketId) {
    return await this.client.get(`applewalletpass/createpass/${ticketId}`, {
      responseType: 'blob'
    });
  }
}

export default WalletService;